import { FileDownload } from "@mui/icons-material";
import { Button, Grid, Typography } from "@mui/material";

const HomeVisitorAssessor = () => {
  const downloadWorksheet = () => {
    const link = document.createElement("a");
    link.download = `HomeVisitorCDAAssessorRecommendationForm.pdf`;
    link.href = "./docs/HomeVisitorCDAAssessorRecommendationForm.pdf";
    link.click();
  };

  return (
    <Grid container mb={2} p={3}>
      <Grid item xs={12} mb={2}>
        <Typography fontWeight={700} fontSize={18}>
          1. Home Visitor Assessor
        </Typography>
        <Typography>
          Select a professional who works as an official Home Visitor Assessor/
          Mentor/ Coach or Instructor in your Home Visitor Program or in your
          training agency to write a letter of recommendation based on his or
          her specific knowledge of your home visiting work with families and
          their children. The CDA Assessor Recommendation form found below or in
          your Competency Standards book must be completed within the past six
          months before you apply. This professional should have been involved
          in your professional life for at least twelve weeks prior to writing
          the recommendation.
        </Typography>
      </Grid>
      <Grid item xs={12} mb={2}>
        <Button
          variant="outlined"
          color="myVerify"
          sx={{ textTransform: "initial" }}
          onClick={downloadWorksheet}
        >
          <FileDownload />
          Download Form
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography>
          This recommendation form must be placed in a sealed envelope and
          returned to you, the Home Visitor Candidate. You are responsible for
          bringing this sealed envelope to your verification visit for your
          Professional Development Specialist to review. For more details
          regarding the Home Visitor CDA Assessor Recommendation Form, please
          review the information provided in your Competency Standards book.
        </Typography>
      </Grid>
    </Grid>
  );
};
export default HomeVisitorAssessor;
